import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";
var useUpdateMeeting = function useUpdateMeeting() {
  return useMutation(["updateMeeting"], function (_ref) {
    var id = _ref.id,
      meeting = _ref.meeting;
    return servicesUtils.postService("/recordings/".concat(id, "/"), meeting);
  });
};
export default useUpdateMeeting;